<template>
	<div class="event-navbar d-flex align-center">
		<router-link
			v-for="link in links"
			:key="link.label"
			:to="{
				name: link.name,
				params: { id: $route.params.id },
			}"
			:class="{
				'event-navbar__link': true,
				'event-navbar__link-active': $route.name === link.name,
			}"
		>
			{{ link.label }}
		</router-link>
	</div>
</template>

<script>
export default {
	data() {
		return {
			links: [
				{ name: 'event-by-id', label: 'General' },
				{ name: 'event-agenda', label: 'Agenda' },
				{ name: 'my-agenda-events', label: 'My Agenda' },
			],
		}
	},
}
</script>

<style lang="scss">
.event-navbar {
	font-family: Montserrat, sans-serif;
	padding: 0 16px;

	a:not(:last-child) {
		margin-right: 16px;
	}

	@media (max-width: 768px) {
		justify-content: space-around;
		width: 100%;
	}
}

.event-navbar__link {
	font-size: 14px;
	font-weight: 700;
	line-height: 17.07px;
	color: #9b9b9b !important;
	text-decoration: none;
	padding: 16px 0;

	&-active {
		color: var(--button-secondary-background-color) !important;

		border-bottom: 1px solid var(--button-secondary-background-color);
	}
}
</style>